import React, { useEffect, useState } from "react";
import { SVGs } from "../../assets/svg/SVGs";
import TextField from "../forms/TextField";
import TextArea from "../forms/TextArea";
import styled from "styled-components";
import {
	reqOptions,
	fetchAPI,
	HOST_URL,
	getCookie,
	printErrNew,
	removeErrMsg,
} from "../../assets/js/help_func";

import {
	openConfirmModal,
	openConfirmWithOTP,
	openToast,
} from "../../assets/js/modals/modals";
import CheckBoxes from "../forms/CheckBoxes";
import DateTimeInput from "../forms/DateTimeInput";
import EmailList from "../forms/EmailList";
import NewSubmitBtn from "../forms/NewSubmitBtn";
import FormError from "../forms/FormError";
import { useSelector } from "react-redux";
import FilterObjects from "../forms/FilterObjects";

// CREATING Email
const CreateEmail = ({ status, setStatus, error, setError, ...props }) => {
	const [data, setData] = useState([]);
	const [group, setGroup] = useState("group");
	const [groupData, setGroupData] = useState(0);
	const [message, setMessage] = useState();
	const [sender, setSender] = useState({});
	const [test, setTest] = useState(false);

	const username = useSelector((state) => state.username.company);

	useEffect(() => {
		if (groupData === 0) {
			// Fetch group data from db if doesn't exist.
			const requestOptions = reqOptions("GET", null, true);
			let access_url =
				HOST_URL + `/api/v1/companies/${username}/company-email-sender-list/`;
			fetchAPI(setSender, access_url, requestOptions, true);
		}
	}, []);

	useEffect(() => {
		if (groupData === 0) {
			// Fetch group data from db if doesn't exist.
			const requestOptions = reqOptions("GET", null, true);
			let access_url = HOST_URL + props.groupUrlPath;
			fetchAPI(setGroupData, access_url, requestOptions, true);
		}

		if (status === 400) {
			removeErrMsg();
			printErrNew(error); // Add message
		}
	}, [groupData, error]);

	const handleCustomSubmit = async (rawData) => {
		// This send custom email without requesting for OTP.
		const requestOptions = reqOptions("POST", rawData, true);
		const url = `${HOST_URL}/api/v1/communications/${username}/send_email/`;
		const req = await fetch(url, requestOptions);
		const res = await req.json();
		const str_msg = JSON.stringify(res);

		if (req.status === 200 || req.status === 201) {
			openToast(res.detail);
			return res;
		} else if (req.status === 401) {
			openToast(str_msg, 401);
		} else {
			openToast(str_msg, req.status);
		}
	};

	const handleFormSubmit = async (e) => {
		e.preventDefault();
		setStatus(0);
		setMessage("");
		removeErrMsg();

		let formData = new FormData(e.target);
		let messageType = formData.get("message_type");
		const idTest = document.getElementById("id_test");

		if (
			(group === "group" &&
				!formData.get(props.groupName) &&
				!idTest.checked) ||
			(group === "custom" && !formData.get("email_list") && !idTest.checked)
		) {
			// Check if groups required.
			openToast("You need to select a group or input custom emails", 400);
			setStatus();
			return;
		}

		// Send email to db.
		if (!formData.get("scheduled_date")) {
			formData.delete("scheduled_date");
		}

		// Confirm if user wants to send email.
		const msg = `Are you sure you want to send mail to ${
			(test && "test group") || group
		}?`;
		const confirm = await openConfirmModal(msg);
		if (!confirm) {
			// Exit function
			setStatus();
			return;
		}

		let new_objects = {};

		if (idTest.checked) {
			// No need for OTP confirmation
			new_objects = await handleCustomSubmit(formData);
		} else {
			// Request for OTP
			const req_otp_url = `${HOST_URL}/api/v1/communications/${username}/send_email/`;
			new_objects = await openConfirmWithOTP(
				req_otp_url,
				req_otp_url,
				formData,
				!idTest.checked
			);
		}

		if (!new_objects) {
			// Exit function
			setStatus();
			return;
		}

		// All these will happen if the confirmation was successful:
		// Update states and reset form.

		setData(new_objects);
		setMessage(new_objects.detail);
		setStatus();

		if (!test) {
			// Reset form if data is returned.
			e.target.reset();
		}
	};

	return (
		<EmailForm className="bills_on_me">
			<div
				onClick={(e) => {
					e.stopPropagation();
				}}
				className="modalContainer"
			>
				<form
					action=""
					onSubmit={handleFormSubmit}
					className="form-overlay swing-in-bottom-fwd"
					id="createEmail"
				>
					<div className="modalHeader">
						<h3>Send Email</h3>
						<div className="otherInput">
							{sender?.results?.length ? (
								<FilterObjects
									options={sender.results}
									labels="Sender"
									names="sender"
								/>
							) : (
								""
							)}
							<div className="radio-buttons">
								<div className="form-group">
									<input
										type="radio"
										id="sendGroup"
										name="message_type"
										defaultValue={props.messageTypes}
										onClick={() => {
											setGroup("group");
										}}
										defaultChecked
									/>
									<label htmlFor="sendGroup">Group</label>
								</div>

								<div className="form-group">
									<input
										type="radio"
										id="sendIndividual"
										defaultValue="CUSTOM"
										name="message_type"
										onClick={() => {
											setGroup("custom");
										}}
									/>
									<label htmlFor="sendIndividual">Custom</label>
								</div>
								<div className="form-group">
									<input
										type="radio"
										id="sendAll"
										defaultValue="ALL"
										name="message_type"
										onClick={() => {
											setGroup("all");
										}}
									/>
									<label htmlFor="sendAll">All Contacts</label>
								</div>
							</div>
						</div>

						{/* if For Group */}
						{group === "group" && (
							<CheckBoxes
								objects={groupData}
								names={props.groupName}
								labels={"Contact Group *"}
							/>
						)}

						{group === "custom" && <EmailList names="email_list" />}

						<TextField
							types="text"
							labels="Email Subject"
							names="email_subject"
							requireds={true}
						/>

						{group === "group" && (
							<p className="help_text mt-5">
								To reference the user name; use <code>first_name</code>. (eg.
								Dear first_name,)
							</p>
						)}
						<TextArea
							types="text"
							labels="Type message..."
							names="description"
							defaultValue=""
							requireds={true}
						/>

						{/* SCHEDULE DATE */}
						<DateTimeInput labels="Schedule Email" names="scheduled_date" />

						<input
							type="text"
							name="company"
							hidden
							value={getCookie("c_id")}
						/>
						<input
							type="text"
							name="email_from"
							hidden
							value={getCookie("c_name")}
						/>

						{/* <span>
              <b> Note:-</b> Plain text email: to reference the user firstname,
              use . Links are to be added without http, eg.
              skills.instincthub.com/students/review/2/16/
            </span> */}

						<CheckBoxes
							objects={[{ id: "test", title: "Send Test" }]}
							names={"test"}
							labels={"Preview"}
							setChecked={setTest}
						/>

						{message && <p className="message">{message}</p>}
						<FormError status={status} errors={error} />
						<NewSubmitBtn labels="Send Email" status={status} />
					</div>
				</form>
				<img
					src={SVGs.close}
					alt=""
					onClick={() => props.setSendEmail(false)}
				/>
			</div>
		</EmailForm>
	);
};

export default CreateEmail;

let EmailForm = styled.section`
	.radio-buttons {
		.form-group {
			margin-bottom: 20px;
			display: inline-block;
			margin-right: 20px;
			margin-top: 10px;
			p {
				margin-left: 30px;
			}
		}
		input[type="radio"] {
			display: none;
		}

		label {
			cursor: pointer;
			position: relative;
			font-size: 16px;
			margin-left: 30px;
		}

		label::before {
			content: "";
			position: absolute;
			width: 20px;
			left: -30px;
			height: 20px;
			background-color: transparent;
			border: 1px solid #00838f;
			border-radius: 50%;
			top: 50%;

			transform: translateY(-50%);
			transition: border-color 400ms ease;
		}

		label::after {
			content: "";
			position: absolute;
			width: 20px;
			height: 20px;
			left: -30px;
			background-color: #00838f;
			border: 1px solid #00838f;
			border-radius: 50%;
			top: 50%;

			transform: translateY(-50%) scale(0);
			transition: transform 400ms ease;
		}

		input[type="radio"]:checked + label::before {
			border-color: #00838f;
		}

		input[type="radio"]:checked + label::after {
			transform: translateY(-50%) scale(0.55);
		}
	}
	.help_text {
		font-size: 14px;
	}
	.message {
		padding: 15px;
		color: var(--ViridianGreen);
	}
`;
